import * as XLSX from 'xlsx'

export const generateTherapistExcelReport = (data, fileName) => {
  const formattedData = data.map((item) => ({
    'Patient Number': item?.patientNumber,
    'Patient Name': item?.patientName,
    'Patient Gender': item?.patientGender,
    'Patient Age': item?.patientAge,
    Currency: item?.transactionCurrency,
    Visits: item?.visits,
    Clinic: item?.clinic,
    'Booking Time': item?.bookingTime,
    'Booking Type': item?.eventTypeTitle,
    Mode: item?.mode,
    'Session Status': item?.sessionCompleted,
    'Next Visit': item?.nextVisitDateGiven,
    'Report Length': item?.reportContentLength,
    'Fee Collected': item?.feeCollected,
    'Therapist Share %': item?.mentorSharePercentage,
    'Therapist Share': item?.mentorShare,
    'Min Fee Used': item?.minimumFeeUsed,
  }))

  const worksheet = XLSX.utils.json_to_sheet(formattedData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Reports')
  XLSX.writeFile(workbook, fileName)
}

export const generateClinicExcelReport = (data, fileName) => {
  // Identify columns where all values are empty strings
  const keysToRemove = [
    { headerTitle: 'Clinic Share Formula', itemKey: 'clinicSharePercentage' },
    { headerTitle: 'Clinic Share', itemKey: 'clinicShare' },
    { headerTitle: 'AUMHUM Share', itemKey: 'aumhumShare' },
    { headerTitle: 'AUMHUM Share Formula', itemKey: 'aumhumSharePercentage' },
    { headerTitle: 'Pay to AUMHUM', itemKey: 'transactionDetails' },
    { headerTitle: 'Min Fee for calculations', itemKey: 'minimumFee' },
  ]

  // Check which keys are actually empty across all items
  const keysWithData = keysToRemove.filter((key) => data.every((item) => !!item?.[key.itemKey]))

  // Map data while removing empty columns
  const formattedData = data.map((item) => {
    const formattedItem = {
      'Patient Number': item?.patientNumber,
      'Patient Name': item?.patientName,
      'Patient Gender': item?.patientGender,
      'Patient Age': item?.patientAge,
      Currency: item?.transactionCurrency,
      Visits: item?.visits,
      'Service Provider': item?.mentor,
      'Booking Time': item?.bookingTime,
      'Booking Type': item?.eventTypeTitle,
      Mode: item?.mode,
      'Fee Collected': item?.feeCollected,
    }

    // Add only keys that are NOT completely empty
    keysWithData.forEach((key) => {
      formattedItem[key.headerTitle] = item[key.itemKey]
    })

    return formattedItem
  })

  const worksheet = XLSX.utils.json_to_sheet(formattedData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Reports')
  XLSX.writeFile(workbook, fileName)
}

export const generateExcelReport = (data, fileName) => {
  // Check if this is therapist data (has mentorShare) or clinic data (has clinicShare)
  const isTherapistData = data.length > 0 && data[0].hasOwnProperty('mentorShare')
  
  if (isTherapistData) {
    generateTherapistExcelReport(data, fileName)
  } else {
    generateClinicExcelReport(data, fileName)
  }
}
